window.Rakuten = (function ($, util) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        func: {
            init: function () {
                self.func.bindings();
                self.func.bindRakutenMembershipForm();
            },
            bindings: function () {
                $(window.RakutenConstants.elements.classes.radioButton).on('click', self.func.bindRakutenMembershipForm);
                $(window.RakutenConstants.elements.id.registeredEmailId).on('change', self.func.validateRegisteredEmailId);
                $(window.RakutenConstants.elements.classes.rakutenCheckboxGuard).on('click', self.func.handleGuardCheck);
                $(window.RakutenConstants.elements.buttons.signUpButton).on('click', self.func.enrolMember);
                $(window.RakutenConstants.elements.buttons.confirmDelink).on('click', self.func.unenrolMember);
                $(window.RakutenConstants.elements.classes.activateBenefitCTA).on('click', self.func.enrolMember);
            },
            bindRakutenMembershipForm: function () {
                if ($(window.RakutenConstants.elements.id.hasRakutenAccount).is(':checked')) {
                    $(window.RakutenConstants.elements.id.rakutenRegistrationForm).hide();
                    $(window.RakutenConstants.elements.id.rakutenSignUpForm).show();
                    self.func.handleGuardCheck();
                }
                if ($(window.RakutenConstants.elements.id.hasNoRakutenAccount).is(':checked')) {
                    $(window.RakutenConstants.elements.buttons.signUpButton).addClass('vds-button--disabled');
                    $(window.RakutenConstants.elements.id.rakutenSignUpForm).hide();
                    $(window.RakutenConstants.elements.id.rakutenRegistrationForm).show();
                }
            },
            handleGuardCheck: function () {
                const partnerTermsCheck = $(window.RakutenConstants.elements.checkboxes.partnerTermsCheck + ':checked').length > 0;
                const isBenefitChecked = $(window.RakutenConstants.elements.checkboxes.benefitCheckBoxes).length === 0 ||
                    $(window.RakutenConstants.elements.checkboxes.benefitCheckBoxes + ':checked').length > 0;
                if (self.func.isValidRegisteredEmailId() && partnerTermsCheck && isBenefitChecked) {
                    $(window.RakutenConstants.elements.buttons.signUpButton).removeClass('vds-button--disabled');
                } else {
                    $(window.RakutenConstants.elements.buttons.signUpButton).addClass('vds-button--disabled');
                }
            },
            validateRegisteredEmailId: function (event) {
                self.func.isValidRegisteredEmailId() ? $(event.target).next('.vds-form__validation-message').hide() :
                    $(event.target).next('.vds-form__validation-message').show();
                self.func.handleGuardCheck();
            },
            isValidRegisteredEmailId: function () {
                const emailId = $(window.RakutenConstants.elements.id.registeredEmailId).val().trim();
                const minEmailLength = 8;
                if (emailId.length < minEmailLength) {
                    return false;
                }
                if (window.RakutenConstants.constants.emailIdRegex.test(emailId)) {
                    const digitRegex = /\d/;
                    return !digitRegex.test(emailId.split('.').pop());
                }

                return false;
            },
            enrolMember: function () {
                $(window.RakutenConstants.elements.buttons.signUpButton).hide();
                $(window.RakutenConstants.elements.buttons.pleaseWaitButton).show();
                util.func.callWebApi({
                    type: 'POST',
                    url: window.RakutenConstants.urls.enrolMember,
                    data: self.func.getData()
                }).done(function (data) {
                    self.func.enrolMemberSuccess(data);
                }).fail(function (error) {
                    self.func.enrolMemberError(error);
                });
            },
            getData: function () {
                const partnerLandingPageId = $('#partnerLandingPageId').val();
                if ($('#isPartnerTrackingPage').val()) {
                    return {
                        rewardType: $('#partner-activate-benefit-notification').data('rewardtype'),
                        landingPageId: partnerLandingPageId,
                        registeredEmailId: $('#partner-activate-benefit-notification').data('rakutenid')
                    };
                }
                if ($('#isPartnerSignUpPage').val()) {
                    return {
                        rewardType: self.func.getRewardType,
                        landingPageId: partnerLandingPageId,
                        registeredEmailId: $(window.RakutenConstants.elements.id.registeredEmailId).val().trim()
                    };
                }
                return null;
            },
            enrolMemberSuccess: function (data) {
                if (data.notificationCode === null) {
                    window.location.replace(data.redirect);
                    window.RakutenGtm.signUp.success();
                } else {
                    self.func.enrolMemberError(data);
                    $(window.RakutenConstants.elements.buttons.pleaseWaitButton).hide();
                    $(window.RakutenConstants.elements.buttons.signUpButton).show();
                    $(window).scrollTop(0);
                }
            },
            enrolMemberError: function (error) {
                const code = error.errorCode === null || error.errorCode === undefined ? error.notificationCode : error.errorCode;
                if (code === util.httpStatusCodes.unauthorized) {
                    util.func.reloadPage();
                    window.RakutenGtm.signUp.failure(code);
                } else if (code === util.httpStatusCodes.forbidden) {
                    util.func.redirect(window.RakutenConstants.urls.errorPage);
                    window.RakutenGtm.signUp.failure(code);
                } else {
                    const category = window.RakutenConstants.notificationCategories.enrolment;
                    self.func.loadNotification(category, 'Rakuten', code);
                    $(window.RakutenConstants.elements.buttons.pleaseWaitButton).hide();
                    $(window.RakutenConstants.elements.buttons.signUpButton).show();
                    window.RakutenGtm.signUp.failure(code);
                }
            },
            getRewardType: function () {
                if ($(window.RakutenConstants.elements.checkboxes.benefitCheckBoxes + ':checked').length > 1 ||
                    $(window.RakutenConstants.elements.checkboxes.benefitCheckBoxes).length === 0) {
                    return $(window.RakutenConstants.elements.checkboxes.partnerTermsCheck).data('value');
                } else {
                    return $(window.RakutenConstants.elements.checkboxes.benefitCheckBoxes + ':checked').data('value');
                }
            },
            unenrolMember: function () {
                const partnerLandingPageId = $('#partnerLandingPageId').val();
                util.func.closeModal('delink-modal');
                util.func.openModal(window.RakutenConstants.elements.id.unenrolmentLoadingModal);
                util.func.callWebApi({
                    type: 'DELETE',
                    url: window.RakutenConstants.urls.unenrolMember,
                    data: {
                        landingPageId: partnerLandingPageId
                    }
                }).done(function (data) {
                    self.func.unenrolMemberResponse(data);
                }).fail(function (error) {
                    self.func.unenrolMemberResponse(error);
                });
            },
            unenrolMemberResponse: function (data) {
                if (data.redirect !== null) {
                    util.func.redirect(data.redirect);
                } else {
                    util.func.closeModal(window.RakutenConstants.elements.id.unenrolmentLoadingModal);
                    $(window.RakutenConstants.elements.buttons.unenrolmentErrorModelClose).on('click',
                        util.func.reloadPage);
                    util.func.openModal(window.RakutenConstants.elements.id.unenrolmentErrorModal);
                }

            },
            loadNotification: function (category, partnerName, notificationCode) {
                $(window.RakutenConstants.elements.id.enrolmentError).remove();
                const data = {
                    category: category,
                    partnerName: partnerName,
                    notificationCode: notificationCode
                };
                $.ajax({
                    method: 'GET',
                    url: window.RakutenConstants.urls.partnerNotification,
                    data: data,
                    success: function (notificationStr) {
                        const notificationHtml = $.parseHTML(notificationStr);
                        $(notificationHtml).attr('id', 'enrolment-error');
                        $(window.RakutenConstants.elements.classes.primaryContainer).prepend(notificationHtml);
                    }
                });
            }

        }
    };
    return {
        init: self.func.init
    };
})(window.jQuery, window.Utilities);

$('document').ready(function () {
    const rakuten = $('#page-data').data('partner-name') === 'Rakuten';
    const healthReviewToggle = ($('#page-data').data('feature-toggle') === 'True')
        if(healthReviewToggle) {
            $("#health-review-toggle-on").show();
            $("#health-review-toggle-off").hide();
        }
        else {
            $("#health-review-toggle-on").hide();
            $("#health-review-toggle-off").show();
        }
    if (rakuten) {
        Rakuten.init();
    }
});
